const InputLabel = ({ label, required }) => {
  return (
    <div className="mb-2 text-sm">
      {label} {required && <span className="text-red-500 font-semibold">*</span>}
    </div>
  );
};

export default InputLabel;
